import {
  createBrowserRouter,
  Navigate,
  RouterProvider
} from "react-router-dom";
import { useSelector } from "react-redux";

import { PrivateFreeLayout } from "../pages/Layout";
import {
  Asistentes,
  Error,
  Legal,
  Perfil,
  Suscripcion,
} from "../pages";
import {
  ConfiguracionSider,
} from "../pages/Layout/PrivateFreeLayout/Siders";
import { roles } from "../types/types";

export const PrivateFreeRouter = () => {

  const { user } = useSelector(state => state.auth);

  let homeElement = <Navigate to="suscripcion" />;
  if(user.rol !== roles.MEDICO){
    homeElement = <Navigate to="home" />;
  }
  
  const router = createBrowserRouter([
    {
      path: "",
      element: <PrivateFreeLayout />,
      errorElement: <Error />,
      children: [
          {
              path: "",
              element: homeElement,
          },
          (user.rol === roles.MEDICO) ? {
              path: "",
              element: <ConfiguracionSider />,
              children: [
              {
                  path: "/perfil",
                  element: <Perfil />,
              },
              {
                  path: "/asistentes",
                  element: <Asistentes />,
              },
              ]
          } : {},
          (user.rol === roles.MEDICO) ? {
              path: "/suscripcion",
              element: <Suscripcion />,
          } : {},
          {
              path: "/legal",
              element: <Legal />,
          },
          {
              path: "/*",
              element: <Navigate to="" />,
          }
      ],
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  )
}